import { render, staticRenderFns } from "./HistoryComponent.vue?vue&type=template&id=5af5ba79&scoped=true&"
import script from "./HistoryComponent.vue?vue&type=script&lang=js&"
export * from "./HistoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./HistoryComponent.vue?vue&type=style&index=0&id=5af5ba79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5ba79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af5ba79')) {
      api.createRecord('5af5ba79', component.options)
    } else {
      api.reload('5af5ba79', component.options)
    }
    module.hot.accept("./HistoryComponent.vue?vue&type=template&id=5af5ba79&scoped=true&", function () {
      api.rerender('5af5ba79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HistoryComponent.vue"
export default component.exports